export type KbToolsConfig = {
	restUrl: string;
	nonce: string;
	remoteEnabled: boolean;
	uiVersion: string;
};

declare global {
	interface Window {
		kbSecurityTools?: KbToolsConfig;
	}
}

export function getConfig(): KbToolsConfig {
	return (
		window.kbSecurityTools || {
			restUrl: '',
			nonce: '',
			remoteEnabled: false,
			uiVersion: '',
		}
	);
}

export async function postCheck<T>(path: string, body: Record<string, unknown>): Promise<T> {
	const cfg = getConfig();
	if (!cfg.remoteEnabled) {
		throw new Error('Remote checks are disabled by the site operator.');
	}
	if (!cfg.restUrl) {
		throw new Error('REST configuration is missing.');
	}
	const url = cfg.restUrl.replace(/\/?$/, '/') + path.replace(/^\//, '');
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': cfg.nonce,
		},
		body: JSON.stringify(body),
		credentials: 'same-origin',
	});
	const data = (await res.json().catch(() => ({}))) as T & { message?: string; code?: string };
	if (!res.ok) {
		const msg =
			typeof data === 'object' && data && 'message' in data && data.message
				? String(data.message)
				: `Request failed (${res.status})`;
		throw new Error(msg);
	}
	return data;
}
